import React from "react";
import { FaSearch, FaChartLine, FaUsers, FaUserPlus } from "react-icons/fa";

const IntroductionSection = ({ isAuthenticated, onSignupClick }) => {
  return (
    <section className="bg-white md:bg-black text-black md:text-white py-12 mt-12 w-full px-6 text-center">
      {/* ✅ 모바일에서는 흰색, 데스크톱에서는 기존 검은색 유지 */}

      <h2 className="text-xl sm:text-2xl font-bold mb-6 flex justify-center items-center gap-2">
        <FaSearch className="text-blue-400 text-2xl sm:text-3xl" />
        쇼핑몰 상품명을 쉽게 만들 수 있는 무료 사이트
      </h2>

      <div className="space-y-6 max-w-3xl md:max-w-4xl mx-auto">
        <p className="text-base sm:text-lg leading-relaxed md:leading-loose flex flex-wrap md:flex-nowrap items-center justify-center gap-2 md:gap-3 whitespace-normal md:whitespace-nowrap">
          <FaChartLine className="text-green-400 text-lg sm:text-xl" />
          네이버 SEO에 최적화된 상품명을 만들기 위해{" "}
          <span className="text-blue-500 font-semibold">키워드 경쟁 강도</span>와{" "}
          <span className="text-green-500 font-semibold">검색량</span>을 분석하는 것이 중요합니다.
        </p>

        <p className="text-base sm:text-lg leading-relaxed md:leading-loose flex flex-wrap md:flex-nowrap items-center justify-center gap-2 md:gap-3 whitespace-normal md:whitespace-nowrap">
          <FaUsers className="text-yellow-500 text-xl sm:text-2xl" />
          매드키워드는 이러한 분석을 쉽고 빠르게 할 수 있도록 도와주는{" "}
          <span className="font-semibold text-yellow-500">무료 사이트</span>입니다.
        </p>

        {!isAuthenticated ? (
          <p className="text-base sm:text-lg leading-relaxed md:leading-loose flex flex-wrap md:flex-nowrap items-center justify-center gap-2 md:gap-3 whitespace-normal md:whitespace-nowrap">
            <FaUserPlus className="text-red-500 text-xl sm:text-2xl" />
            지금 <span className="font-semibold text-red-500">무료 회원가입</span> 후 로그인하면 사이트를 이용할 수 있습니다!
          </p>
        ) : (
          <p className="text-base sm:text-lg leading-relaxed md:leading-loose flex flex-wrap md:flex-nowrap items-center justify-center gap-2 md:gap-3 whitespace-normal md:whitespace-nowrap">
            <FaUserPlus className="text-red-500 text-xl sm:text-2xl" />
            지금 <span className="font-semibold text-red-500">검색창에</span> 검색어 입력하시면 사용할 수 있습니다.
          </p>
        )}
      </div>

      {!isAuthenticated && (
        <button
          onClick={onSignupClick}
          className="mt-6 bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition-all duration-300 flex items-center gap-2 mx-auto"
        >
          <FaUserPlus className="text-white text-lg" />
          무료 회원가입 & 로그인
        </button>
      )}
    </section>
  );
};

export default IntroductionSection;
